export { default } from '@shikijs/langs/javascript'
